import styled from 'styled-components';
import { Link } from 'react-router-dom';

/* O rail de cartões que nasceu no "Fique por dentro" da Home, agora
   compartilhado (Home e "Outros álbuns" da galeria). Os valores são os de lá. */

export const Cabeca = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  /* 2.25rem de respiro menos o padding-top do rail. */
  margin-bottom: 1.5rem;
  text-align: left;

  @media only screen and (max-width: 750px) {
    margin-bottom: 0.75rem;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  /* O "&&" ganha do h2 geral da Home (centralizado, 70px acima, traço no
     meio), que vencia por vir depois: o título fica igual ao de "Nossas frentes
     de trabalho". */
  && h2 {
    width: auto;
    text-align: left;
    margin: 0.5rem 0 0;
    font-size: clamp(1.5rem, 2.5vw + 1rem, 2.25rem);
    font-weight: 700;
    line-height: 1.2;
    color: #17251b;

    &::after {
      content: '';
      display: block;
      width: 3rem;
      height: 0.1875rem;
      margin: 0.875rem 0 0;
      border-radius: 0.25rem;
      /* Âmbar, como os traços do resto do site. */
      background: var(--sixth-color);
    }
  }
`;

export const Chapeu = styled.span`
  display: block;
  color: var(--second-color);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

export const Setas = styled.div`
  display: flex;
  gap: 0.625rem;
  flex-shrink: 0;
`;

export const Seta = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  padding: 0;
  border: 1px solid #dde5dc;
  border-radius: 0.75rem;
  background: var(--white-color);
  color: var(--first-color);
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: var(--second-color);
    box-shadow: 0 0.25rem 0.75rem rgba(0, 137, 58, 0.15);
    transform: translateY(-0.0625rem);
  }

  @media only screen and (max-width: 750px) {
    width: 2.25rem;
    height: 2.25rem;
  }
`;

export const Trilho = styled.div`
  display: flex;
  gap: 1.5rem;
  overflow-x: auto;
  /* proximity (em vez de mandatory) deixa o encaixe menos travado: o snap só
     entra quando a rolagem já para perto de um card. */
  scroll-snap-type: x proximity;
  /* overflow-x: auto faz o eixo vertical também recortar, então o card cortava
     no topo ao subir no hover. Este padding reserva espaço para o movimento e
     para a sombra (o de cima é descontado da margem do cabeçalho). */
  padding: 0.75rem 0 1rem;

  /* A navegação é pelas setas: a barra de rolagem fica oculta (o swipe no
     touch e a rolagem horizontal continuam funcionando). */
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media only screen and (max-width: 750px) {
    /* Cada card com a própria altura: com um por tela, igualar a altura de
       todos só cria vazio entre o texto e o link. */
    align-items: flex-start;
  }
`;

export const Cartao = styled.article`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 0 0 clamp(17rem, 26vw, 23.5rem);
  scroll-snap-align: start;
  padding: 1rem;
  background: var(--white-color);
  border: 1px solid #e4e9e3;
  border-radius: 0.875rem;
  text-align: left;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;

  &:hover {
    border-color: #cfe0d1;
    box-shadow: 0 0.5rem 1.25rem rgba(0, 137, 58, 0.12);
    transform: translateY(-0.25rem);
  }

  h3 {
    margin: 0;
    color: #1b2a20;
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.3;

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  p {
    margin: 0.75rem 0 0;
    color: #4b554d;
    font-size: 0.9375rem;
    line-height: 1.65;

    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media only screen and (max-width: 750px) {
    flex-basis: 80vw;

    h3 {
      font-size: 1.125rem;
      -webkit-line-clamp: 2;
    }

    p {
      -webkit-line-clamp: 3;
    }
  }
`;

export const Imagem = styled.img`
  /* Sangra até a borda do card (anula o padding de 1rem) com o recorte 3/2.
     O arredondamento vem do próprio border-radius da imagem, acompanhando o
     raio interno do card (0.875rem menos a borda de 1px) -- fazer isso via
     overflow: hidden no card quebrava o clipping junto com o transform do
     hover, e a imagem aparecia cortada e com os cantos retos. */
  display: block;
  width: calc(100% + 2rem);
  margin: -1rem -1rem 1.125rem;
  aspect-ratio: 3 / 2;
  object-fit: cover;
  border-radius: 0.8125rem 0.8125rem 0 0;
  background: #f1f3f0;

  /* Foto em pé: o recorte fica perto do topo, para cortar os pés e não o rosto. */
  &[data-retrato] {
    object-position: 50% 12%;
  }
`;

export const Etiqueta = styled.span`
  display: block;
  margin-bottom: 0.625rem;
  color: var(--second-color);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
`;

export const Acao = styled(Link)`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.375rem;
  /* auto mantém o link na base, alinhado entre cards de alturas diferentes */
  margin-top: auto;
  padding-top: 1.5rem;
  font-size: 0.9375rem;
  font-weight: 600;
  text-decoration: none;

  /* A cor vale em todos os estados. Sem isto, o a:visited do GlobalStyle
     (color: inherit) vencia depois do primeiro clique, e o "Leia mais" da
     notícia já lida ficava preto. O && dobra a classe para ganhar dele. */
  &&,
  &&:visited {
    color: var(--second-color);
  }

  .seta {
    transition: transform 0.25s ease;
  }

  &&:hover {
    color: var(--first-color);

    .seta {
      transform: translateX(0.1875rem);
    }
  }

  /* No estreito o card tem a própria altura, então o auto não tem sobra para
     empurrar -- e o padding encosta o link no texto. */
  @media only screen and (max-width: 750px) {
    margin-top: 0;
    padding-top: 1rem;
  }
`;
